import React, { useState } from 'react';
import PersonalizedMessage from "./PersonalizedMessage";
import HeartfeltPoem from "./HeartfeltPoem";
import RoastMe from "./RoastMe";
import "./App.css"; // Add CSS for global styles
import { Link } from 'react-router-dom';

const RoastGenerator = () => {
  

  const currentTheme = {
      background: "#e6f7ff",
      text: "#0050b3",
      hover: { background: "#bae7ff", text: "#003a8c" },
    };

  return (
    <div 
      className="app-container"
      style={{
        backgroundColor: currentTheme.background,
        transition: "background-color 0.3s ease-in-out",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <title>Roast Me - Personalized, Funny, and Witty Roasts | Message Melody</title>
      <meta name="description" content="Get a personalized, funny roast that's witty, humorous, and tailored just for you. Try our Roast Me page to add some humor to your day!"/>
      <meta name="keywords" content="roast me, funny roasts, personalized roasts, witty humor, custom roasts, roast generator"/>
      <meta property="og:title" content="Roast Me - Funny Personalized Roasts" />
      <meta property="og:description" content="Get a roast tailored to your personality and share the laughs with your friends." />
      <meta property="og:image" content="https://messagemelody.com/message-melody.jpg" />
      <meta property="og:url" content="https://messagemelody.com/roast-me" />

      <div
        style={{
          textAlign: "center",
          color: currentTheme.text,
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        Roast Me!
      </div>
      <div
        style={{
          textAlign: "center",
          color: "#333",
          fontSize: "18px",
          fontWeight: "normal",
          marginBottom: "20px",
        }}
      >
        Your Personalized Roasting, Served with a Side of Humor
        Like and Share it with your friends.
      </div>
      <div
        style={{
          textAlign: "center",
          color: "#333",
          fontSize: "18px",
          fontWeight: "normal",
          marginBottom: "20px",
        }}
      >
        Switch to {' '} <Link to="/" style={{ color: currentTheme.text, textDecoration: 'underline' }}>
          Messages/Poems
        </Link>.
      </div>
      <div className="feature-container">
        <RoastMe />
      </div>
    </div>
  );
};

export default RoastGenerator;
